// extracted by mini-css-extract-plugin
module.exports = {"root":"IconMinus_root__3FUzL"};